module.exports = __webpack_public_path__ + "static/media/icon-report-school-report.89c79b9b.svg";